module.exports = __webpack_public_path__ + "img/balkon_2.420312f5.webp";